import BasicSettings from './BasicSettings';

export default (props) => {
  return <BasicSettings {...props} />;
};
